import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { SavingGuard } from './app/SavingGuard';
import { AppearanceProvider } from './design-system/providers/AppearanceProvider';
import { I18nProvider } from './i18n/I18nProvider';

// Tokens first: reset.css reads --color-bg, --color-text, --focus-ring-width and
// --color-accent-line, so the sheet defining them must enter the cascade before it.
import './design-system/tokens.css';
import './styles/reset.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

// The appearance provider sits outside everything: it owns the only global
// switches, and task 24's topbar reads them back through useAppearance. The
// plan's task 18 never mounts it, which would have left the persisted
// preference read by index.html's boot script and then never maintained.
// I18nProvider sits *inside* AppearanceProvider and subscribes to its `locale`:
// one owner for the switch, one writer for `lang` and `dir`, and the strings
// follow. Mounted the other way round it would throw, which is the point.
createRoot(container).render(
  <StrictMode>
    <AppearanceProvider>
      <I18nProvider>
        <App />
        <SavingGuard />
      </I18nProvider>
    </AppearanceProvider>
  </StrictMode>,
);
